export const TextLang: any = {
    us: {
        redeem_now: 'REDEEM NOW',
        site_account_profile_save_success: 'Success',
        stock_left: '{stock} Left',
        off: 'OFF',
        order_text: 'Order',
        points: 'EcoCredits',
        rules: 'Rules',
        coupon: 'Discount code',
        gift_card: 'Gift Card',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        expired_in: 'Expires in:',
    },
    ca: {
        redeem_now: 'REDEEM NOW',
        site_account_profile_save_success: 'Success',
        stock_left: '{stock} Left',
        off: 'OFF',
        order_text: 'Order',
        points: 'EcoCredits',
        rules: 'Rules',
        coupon: 'Discount code',
        gift_card: 'Gift Card',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        expired_in: 'Expires in:',
    },
    eu: {
        redeem_now: 'REDEEM NOW',
        site_account_profile_save_success: 'Success',
        stock_left: '{stock} Left',
        off: 'OFF',
        order_text: 'Order',
        points: 'EcoCredits',
        rules: 'Rules',
        coupon: 'Discount code',
        gift_card: 'Gift Card',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        expired_in: 'Expires in:',
    },
    za: {
        redeem_now: 'REDEEM NOW',
        site_account_profile_save_success: 'Success',
        stock_left: '{stock} Left',
        off: 'OFF',
        order_text: 'Order',
        points: 'EcoCredits',
        rules: 'Rules',
        coupon: 'Discount code',
        gift_card: 'Gift Card',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        expired_in: 'Expires in:',
    },
    au: {
        redeem_now: 'REDEEM NOW',
        site_account_profile_save_success: 'Success',
        stock_left: '{stock} Left',
        off: 'OFF',
        order_text: 'Order',
        points: 'EcoCredits',
        rules: 'Rules',
        coupon: 'Discount code',
        gift_card: 'Gift Card',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        expired_in: 'Expires in:',
    },
    uk: {
        redeem_now: 'REDEEM NOW',
        site_account_profile_save_success: 'Success',
        stock_left: '{stock} Left',
        off: 'OFF',
        order_text: 'Order',
        points: 'EcoCredits',
        rules: 'Rules',
        coupon: 'Discount code',
        gift_card: 'Gift Card',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        expired_in: 'Expires in:',
    },
    de: {
        redeem_now: 'JETZT EINLÖSEN',
        site_account_profile_save_success: 'Erfolgreich abgegeben',
        stock_left: '{stock} übrig',
        off: 'RABATTE',
        order_text: 'Bestellung',
        points: 'EcoCredits',
        rules: 'Regeln',
        coupon: 'Coupon',
        gift_card: 'Geschenkkarte',
        available: 'Verfügbar',
        redeemed: 'Eingelöst',
        expired: 'Abgelaufen',
        expired_in: 'Verfällt in:',
    },
    fr: {
        redeem_now: 'ÉCHANGER MAINTENANT',
        site_account_profile_save_success: 'Enregistré',
        stock_left: '{stock} restants',
        off: 'DE RÉDUCTION',
        order_text: 'Commande',
        points: 'EcoCredits',
        rules: 'Règles',
        coupon: 'Code de réduction',
        gift_card: 'Carte-cadeau',
        available: 'Disponible',
        redeemed: 'Échangées',
        expired: 'Arrivé à expiration',
        expired_in: 'Temps restant:',
    },
    es: {
        redeem_now: 'CANJEAR AHORA',
        site_account_profile_save_success: 'Enviado con éxito',
        stock_left: '{stock} Restantes',
        off: 'DESCUENTO',
        order_text: 'Pedido',
        points: 'EcoCredits',
        rules: 'Reglas',
        coupon: 'Código de descuento',
        gift_card: 'Tarjeta regalo',
        available: 'Disponible',
        redeemed: 'Canjeadas',
        expired: 'Caducado',
        expired_in: 'Tiempo restante:',
    },
    it: {
        redeem_now: 'RISCATTA ORA',
        site_account_profile_save_success: 'Inviata con successo',
        stock_left: '{stock} Rimasti',
        off: 'OFF',
        order_text: 'Ordine',
        points: 'EcoCredits',
        rules: 'Regole',
        coupon: 'Codice di sconto',
        gift_card: 'Buono regalo',
        available: 'Disponibili',
        redeemed: 'Riscattate',
        expired: 'Scaduti',
        expired_in: 'Tempo rimasto:',
    },
    jp: {
        redeem_now: '今すぐ交換',
        site_account_profile_save_success: '提出は完了しました',
        stock_left: '残り{stock}個/台',
        off: 'OFF',
        order_text: '注文',
        points: 'ポイント',
        rules: '条件',
        coupon: 'ディスカウントコード',
        gift_card: 'ギフトカード',
        available: '使用可能',
        redeemed: '使用済み',
        expired: '期限切れ',
        expired_in: '失効まで：',
    },
    kr: {
        redeem_now: '바로 사용하기',
        site_account_profile_save_success: '성공',
        stock_left: '{stock}개가 남았습니다.',
        off: '할인',
        order_text: '주문 번호',
        points: '포인트',
        rules: '포인트 사용 규칙',
        coupon: '할인 쿠폰',
        gift_card: '기프트 카드',
        available: '사용 가능',
        redeemed: '사용됨',
        expired: '만료됨',
        expired_in: '남은 시간:',
    },
    br: {
        redeem_now: 'RESGATE AGORA',
        site_account_profile_save_success: 'Sucesso',
        stock_left: '{stock} restante',
        off: 'DESCONTO',
        order_text: 'Pedido',
        points: 'EcoCredits',
        rules: 'Regras',
        coupon: 'Código de desconto',
        gift_card: 'Gift Card',
        available: 'Disponível',
        redeemed: 'Resgatados',
        expired: 'Expirados',
        expired_in: 'Expira em:',
    },
    mx: {
        redeem_now: 'CANJEAR AHORA',
        site_account_profile_save_success: 'Éxito',
        stock_left: '{stock} restantes',
        off: 'DE DESCUENTO',
        order_text: 'Pedido',
        points: 'EcoCredits',
        rules: 'Reglas',
        coupon: 'Código de descuento',
        gift_card: 'Gift Card',
        available: 'Disponible',
        redeemed: 'Canjeado',
        expired: 'Caducado',
        expired_in: 'Vence el:',
    },
    nl: {
        redeem_now: 'NU INWISSELEN',
        site_account_profile_save_success: 'Succes',
        stock_left: '{stock} over',
        off: 'KORTING',
        order_text: 'Bestelling',
        points: 'EcoCredits',
        rules: 'Regels',
        coupon: 'Kortingscode',
        gift_card: 'Cadeaubon',
        available: 'Beschikbaar',
        redeemed: 'Ingewisseld',
        expired: 'Verlopen',
        expired_in: 'Verloopt over:',
    },
};
